import GenericModal from '../../../Components/GenericModal'
import { useMutation, useQueryClient } from 'react-query'
import { AxiosResponse } from 'axios'
import { useParams } from 'react-router-dom'
import { usePhaseContext } from '../ConfigurePhase/PhaseAccordion'
import { useUserContext } from '../../../Contexts/UserConfig'
import PyAPI from '../../../APIs/Python/APIs/PyAPI'

function DeleteAttributeModal({
  attributeId,
  setAttributeId,
}: {
  attributeId: number | null
  setAttributeId: any
}) {
  const { whoAmI } = useUserContext()
  const queryClient = useQueryClient()
  const phase = usePhaseContext()
  const { study_id } = useParams()

  const {
    mutate: deleteAttribute,
    error,
    isLoading,
    reset,
  } = useMutation<any, AxiosResponse>(
    () =>
      PyAPI.deleteCall(
        whoAmI,
        `/study/${study_id}/phase/${phase.PhaseID}/attribute?attr_id=${attributeId}`,
      ),
    {
      onSuccess: async () => {
        setAttributeId(null)
        await queryClient.invalidateQueries({
          queryKey: ['PyAPI', '/study'],
        })
      },
    },
  )

  return (
    <GenericModal
      open={!!attributeId}
      loading={isLoading}
      error={error}
      setClose={() => {
        setAttributeId(null)
        reset()
      }}
      setCommit={deleteAttribute}
      title={'Are you sure you wish to delete this attribute?'}
      commitLabel={'Yes, delete'}
    ></GenericModal>
  )
}

export default DeleteAttributeModal
